import React from 'react'
import {css} from '@emotion/react'
import styled from '@emotion/styled'

import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'
import {
  DEFAULT_PROVIDER_CODE,
  DEFAULT_PROVIDER_NAME,
  getProviderName,
  isBookWithHotelProvider
} from '@daedalus/core/src/utils/provider'

import {Text} from '../Text'

const StyledText = styled(Text)(
  ({theme}) => css`
    color: ${theme.colors.content.neutral.c950};
  `
)

interface Props {
  /** Pass through classname to allow styles overrides */
  className?: string
  /** Provider code **/
  providerCode: string
  /** The size of the text */
  size?: 'sm' | 'md'
}

export const ProviderName = ({providerCode, size = 'md', className}: Props) => {
  let providerName = getProviderName(providerCode)
  const isBookWithHotel = isBookWithHotelProvider(providerCode)

  if (!isBookWithHotel && !providerName) {
    // eslint-disable-next-line fp/no-mutation
    providerCode = DEFAULT_PROVIDER_CODE
    // eslint-disable-next-line fp/no-mutation
    providerName = DEFAULT_PROVIDER_NAME
  }

  return (
    <StyledText
      as="span"
      variant={size === 'sm' ? 'bodyXS' : 'titleS'}
      className={className}
    >
      {isBookWithHotel ? (
        <FormattedMessageWrapper
          id="bookWithHotel"
          defaultMessage="Book with hotel"
        />
      ) : (
        providerName
      )}
    </StyledText>
  )
}
